// config.js

const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  (window.location.hostname === 'localhost'
    ? 'http://127.0.0.1:8000'
    : 'https://tudu-backend-kwuf.onrender.com');

export default API_BASE_URL;
